import { UseFormReturn } from "react-hook-form";
import { IInventoryProductCatalogueFormFields } from "../CatalogDetailsFormComponent";

export interface IInventoryBatchFormFields {
  parent_name: string;
  name: string;
  vmscategory: string;
  vmscategoryId: string;
  vmsSubcategory: string;
  vmsSubcategoryId: string;
  parentTitle: string;
  parentTitleId: string;
  isproductParent: string;
  productQuantity: number;
  shrinkage: boolean;
  visibility: boolean;
  salt_name: string;
  prescription_type: string;
  logic_type: string;
  logic_formula: number;
  have_parent: boolean;
  is_medicine: boolean;
  is_available: boolean;
  is_pack: boolean;
  is_pack_sell_eligible: boolean;
  bar_code: Array<string>;
  unit: string;
  weight_size: number;
  comment: string;
  sku_name: string;
  billing_name: string;
  tams_margin: number;
  brand: string;
  brandId: string;
  discount_bucket: string;
  tags: Array<string>;
  animalType: string;
  rtv: string;
  rtvDays: number;
  hsncode: string;
  cgst: number;
  sgst: number;
  igst: number;
  ugst: number;
  outward_hsncode: string;
  outward_cgst: number;
  outward_sgst: number;
  outward_igst: number;
  outward_ugst: number;
  upcs: {
    upcname: string;
    image_url: File | string | null;
  }[];
  lots?: {
    lot_number: string;
    mrp: number | null;
    date: string;
    image_url: File | string | null;
  }[];
  permissible_variance: number;
  reference_mrp: number;
  is_shrinkable: boolean;
  status: boolean;
  avg_mrp: number;
}

export type IInventoryFormFields = IInventoryBatchFormFields & IInventoryProductCatalogueFormFields;

export const logicType = [
  {
    id: "1",
    title: "Static",
  },
  {
    id: "2",
    title: "Weight",
  },
];

export const rtvAllowed = [
  {
    id: "1",
    title: "Yes",
  },
  {
    id: "2",
    title: "No",
  },
];

export const prescriptionType = [
  {
    id: "1",
    title: "Generic",
  },
  {
    id: "2",
    title: "Specific",
  },
  {
    id: "3",
    title: "Not Required",
  },
];

export interface Props {
  formHook: UseFormReturn<IInventoryFormFields>;
  onParentTitleIdChange: (id: string | null) => void;
}
